import { Component, EventEmitter, OnDestroy, OnInit } from "@angular/core";
import { takeUntil } from "rxjs/operators";

import {  AppNavService } from "@lantern/app/core";
import { AppNavItem  } from "@lantern/app/models";

@Component({
  selector: "ta-app-nav",
  templateUrl: "./app-nav.template.html"
})
export class AppNavComponent implements OnInit, OnDestroy {
  private onDestroyEmitter = new EventEmitter<void>();

  menu: AppNavItem[] = [];
  layers: AppNavItem[][] = [];

  constructor(private navService: AppNavService) {}

  // On selecting menu item, add layer of child menu items
  onSelect(event: Event, item: any): void {
    event.preventDefault();
    event.stopPropagation();

    if (item.items) {
      this.addLayer(item.items);
    }
  }

  // On clicking back, remove top menu layer
  onBack(event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    this.removeLayer();
  }

  ngOnInit(): void {
    this.navService.filteredMenu$.pipe(
      takeUntil(this.onDestroyEmitter)
    ).subscribe((menu) => {
      this.menu = menu;
      this.layers = menu.length ? [menu] : [];
    });
  }

  ngOnDestroy(): void {
    this.onDestroyEmitter.emit();
    this.onDestroyEmitter.complete();
  }

  private addLayer(layer: AppNavItem[]): void {
    this.layers.push(layer);
  }

  private removeLayer(): void {
    if (this.layers.length > 1) {
      this.layers.pop();
    }
  }
}
